import { memo, useCallback } from 'react'
import { Paper } from '@mui/material'
import { Body2, Stack, Tooltip } from '@collaborate-health/uikit'
import { Lock } from '@mui/icons-material'
import SearchResultRowButton from '../SearchResultButton/SearchResultButton'

interface SearchContentResultItemProps {
  content: {
    Description: string
    IsActive: boolean
  }
  button: string
  handleButtonClick: (content: { Description: string; IsActive: boolean }) => void
}

const SearchContentResultItem: React.FC<SearchContentResultItemProps> = ({ content, button, handleButtonClick }) => {
  const _handleClick = useCallback(() => {
    if (content.IsActive) {
      handleButtonClick(content)
    }
  }, [handleButtonClick, content])

  return (
    <Paper variant='outlined'>
      <Stack direction='row' alignItems='center' justifyContent='space-between' p={0.5}>
        <Stack direction='row' alignItems='center'>
          {!content.IsActive && <Lock />}
          <Tooltip text={content.Description} placement='top'>
            <Body2 overflow='hidden' textOverflow='ellipsis' whiteSpace='nowrap' maxWidth={450}>
              {content.Description}
            </Body2>
          </Tooltip>
        </Stack>
        {content.IsActive && <SearchResultRowButton button={button} handleButtonClick={_handleClick} />}
      </Stack>
    </Paper>
  )
}

export default memo(SearchContentResultItem)

